import {
  ButtonType,
  CovButton,
  CovDialog,
  CovIcon,
  IconName,
} from "@cx-component-library/react-components";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface RemoveFromCollectionDialogProps {
  open: boolean;
  collectionName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirms removing a bookmarked material from one collection (CX-3519 AC6). */
export const RemoveFromCollectionDialog = ({
  open,
  collectionName,
  onCancel,
  onConfirm,
}: RemoveFromCollectionDialogProps) => {
  const { t } = useTranslation();

  return (
    <CovDialog
      open={open}
      onClose={onCancel}
      hasCloseButton={true}
      isBannerLight={true}
      bannerContent={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "var(--spacing14)",
          }}
        >
          <CovIcon
            iconName={IconName.WARNING_AMBER}
            iconColor="var(--global-orange-orange-6)"
            iconSize="x2"
          />
        </Box>
      }
      title={t("src_collection_remove_title")}
      subTitle={t("src_collection_remove_subtitle", { name: collectionName })}
      actions={
        <>
          <CovButton
            buttonType={ButtonType.SECONDARY_OUTLINE}
            onClick={onConfirm}
          >
            {t("src_collection_remove_confirm")}
          </CovButton>
          <CovButton buttonType={ButtonType.PRIMARY} onClick={onCancel}>
            {t("src_collection_remove_cancel")}
          </CovButton>
        </>
      }
    />
  );
};
